
// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
import UIButton from "../../components/core/UIButton";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class BtnCarouselArrowRight extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 18, y ?? 30.5);

    // arrow_carousel_png
    const arrow_carousel_png = scene.add.image(0, 0, "common", "btn-scroll-right.png");
    this.add(arrow_carousel_png);

    // this (components)
    new UIButton(this);

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
